// @ts-nocheck

import palette from '../palette';

import { withOpacity } from './helpers';

export const PokerButton = {
  borderColor: palette.yellowwinamax450,
  color: palette.yellowwinamax450,
};

export const ConnectButton = {
  color: palette.white,
  backgroundColor: palette.red200,
};

export const BankrollDiff = {
  colorPositive: palette.greenwin,
  colorNegative: palette.red200,
  backgroundColor: withOpacity(palette.bluegrey850, 'aa'),
};
